// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"61da5a27","314":"cf76484c","411":"5cd657b0","691":"b7a53f23","867":"b8c53be3","994":"353fed5f"}[chunkId] + ".chunk.css";
};